import {Component, Input} from '@angular/core';
import {SegmentInfluencerSummarize} from '../../../../../models/measure/report';

@Component({
  selector: 'influencer-summarize',
  templateUrl: './influencer-summarize.component.html',
  styleUrls: ['./influencer-summarize.component.scss']
})
export class InfluencerSummarizeComponent {

  @Input()
  influencer: SegmentInfluencerSummarize;

  constructor() { }

}



// WEBPACK FOOTER //
// ./src/app/main/measure/influencer-overview-report/influencer-summarize/influencer-summarize.component.ts